/** @jsxImportSource @emotion/react */
import Divider from '@mui/material/Divider'

import { EmailTemplateTypeEnum } from '__generatedTypes__/globalTypes'
import Loader from 'components/Loader'
import { useEmailTemplate } from '../hooks'
import { MemberForm } from './MemberForm'
import { AdminForm } from './AdminForm'
import * as classes from './styles'

type Props = {
  memberEmailType: EmailTemplateTypeEnum
  adminEmailType: EmailTemplateTypeEnum
  platformId?: string
}

export const SeparateEmail = ({ memberEmailType, adminEmailType, platformId }: Props) => {
  const { templateLoading: memberTemplateLoading } = useEmailTemplate(memberEmailType, platformId)
  const { templateLoading: adminTemplateLoading } = useEmailTemplate(adminEmailType, platformId)

  if (memberTemplateLoading || adminTemplateLoading) {
    return <Loader />
  }

  return (
    <>
      <MemberForm type={memberEmailType} platformId={platformId} />

      <Divider css={classes.divider} />

      <AdminForm type={adminEmailType} platformId={platformId} />
    </>
  )
}
